export const RESEND_COMMISSION_STATEMENT = gql`
    mutation resendCommissionStatement($id: Int!, $recipients: [String!]!) {
        resendCommissionStatement(id: $id, recipients: $recipients)
    }
`;
